export default __webpack_public_path__ + "static/media/video.ac1c04a9.mp4";